var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYardRolesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5416_2202",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5416_2202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56693 11.0355H8.43356V7.2022H7.56693V11.0355ZM7.99673 6.19451C8.12942 6.19451 8.24181 6.14964 8.33389 6.0599C8.42598 5.97014 8.47203 5.85893 8.47203 5.72625C8.47203 5.59357 8.42715 5.48118 8.33739 5.38908C8.24765 5.29699 8.13644 5.25095 8.00376 5.25095C7.87107 5.25095 7.75868 5.29583 7.66659 5.38558C7.5745 5.47534 7.52846 5.58655 7.52846 5.71923C7.52846 5.85191 7.57334 5.96429 7.66309 6.05638C7.75284 6.14847 7.86405 6.19451 7.99673 6.19451ZM8.00596 14.0688C7.17138 14.0688 6.38538 13.911 5.64796 13.5952C4.91053 13.2794 4.26507 12.8449 3.71159 12.2917C3.15811 11.7384 2.7234 11.0935 2.40748 10.3569C2.09155 9.62028 1.93359 8.8332 1.93359 7.99568C1.93359 7.15815 2.09148 6.37345 2.40726 5.64158C2.72304 4.9097 3.15754 4.26703 3.71076 3.71355C4.26399 3.16006 4.90892 2.72535 5.64554 2.40943C6.38217 2.09351 7.16924 1.93555 8.00676 1.93555C8.84429 1.93555 9.62899 2.09344 10.3609 2.40921C11.0927 2.72499 11.7354 3.15949 12.2889 3.71271C12.8424 4.26595 13.2771 4.90958 13.593 5.6436C13.9089 6.37762 14.0669 7.16191 14.0669 7.99648C14.0669 8.83106 13.909 9.61706 13.5932 10.3545C13.2774 11.0919 12.8429 11.7374 12.2897 12.2908C11.7365 12.8443 11.0929 13.279 10.3588 13.595C9.62482 13.9109 8.84053 14.0688 8.00596 14.0688ZM8.00024 13.2022C9.44469 13.2022 10.6725 12.6966 11.6836 11.6855C12.6947 10.6744 13.2002 9.44664 13.2002 8.0022C13.2002 6.55775 12.6947 5.32998 11.6836 4.31886C10.6725 3.30775 9.44469 2.8022 8.00024 2.8022C6.5558 2.8022 5.32802 3.30775 4.31691 4.31886C3.3058 5.32998 2.80024 6.55775 2.80024 8.0022C2.80024 9.44664 3.3058 10.6744 4.31691 11.6855C5.32802 12.6966 6.5558 13.2022 8.00024 13.2022Z",
    fill: "#00838F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYardRolesIcon);
export default __webpack_public_path__ + "static/media/yardRolesIcon.f6be08176dea759244c7e9d4e2e1b63c.svg";
export { ForwardRef as ReactComponent };